import { GET_USERS, UPDATE_USER_ROLE } from "../types";

const AdminReducer = (state, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload.items,
        usersPage: action.payload.page,
        usersTotal: action.payload.total,
        usersHasMore: action.payload.has_more,
        usersPageSize: action.payload.page_size,
        loading: false,
      };
    case UPDATE_USER_ROLE:
      return {
        ...state,
        users: state.users.map((u) =>
          u.user_id === action.payload.user_id
            ? { ...u, role: action.payload.role }
            : u
        ),
      };
    default:
      return state;
  }
};

export default AdminReducer;
